import { cn } from '@ahm/common-helpers';
import type { ComponentProps, HTMLAttributes } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../avatar';
export type AIMessageProps = HTMLAttributes<HTMLDivElement> & {
  from: 'user' | 'assistant';
};
export const AIMessage = ({ className, from, ...props }: AIMessageProps) => (
  <div
    className={cn(
      'group flex w-full items-end justify-end gap-2 py-4',
      from === 'user' ? 'is-user' : 'is-assistant flex-row-reverse justify-end',
      '[&>div]:max-w-[80%]',
      className
    )}
    {...props}
  />
);
export type AIMessageContentProps = HTMLAttributes<HTMLDivElement>;
export const AIMessageContent = ({
  children,
  className,
  ...props
}: AIMessageContentProps) => (
  <div
    className={cn(
      'rounded-lg bg-gradient-to-b from-primary-60 via-yellow-30 to-secondary-50 p-[1px] group-[.is-user]:p-0'
    )}
  >
    <div
      className={cn(
        'flex flex-col gap-2 rounded-lg px-4 py-3 text-sm',
        'bg-white text-foreground ',
        'group-[.is-user]:bg-primary-10 group-[.is-user]:shadow-4 group-[.is-user]:text-primary-50 group-[.is-user]:font-semibold group-[.is-user]:border-none',
        className
      )}
      {...props}
    >
      <div className="is-user:dark">{children}</div>
    </div>
  </div>
);
export type AIMessageAvatarProps = ComponentProps<typeof Avatar> & {
  src: string;
  name?: string;
};
export const AIMessageAvatar = ({
  src,
  name,
  className,
  ...props
}: AIMessageAvatarProps) => (
  <Avatar className={cn('size-8', className)} {...props}>
    <AvatarImage alt="" className="my-0" src={src} />
    <AvatarFallback>{name?.slice(0, 2) ?? 'ME'}</AvatarFallback>
  </Avatar>
);
